<template>
  <div>

    <div class="url-list">
      <div v-if="urlsWithHttp.length === 0">No URLs found in the Video file.</div>
      <div v-else>
        <div class="image-scroll-container">
          <div class="image-container">
            <!-- Iterate over the URLs and display each video -->
            <div v-for="(url, index) in urlsWithHttp" :key="index" class="video-container">

              <video width="400" controls="controls" preload="metadata">
                <source :src="url" type="video/mp4">
              </video>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ArrayVideo',
  props: {

    projectKey: {
      type: String,
      required: true
    },
    urls: {
      type: Array,
      required: true
    }
  },

  computed: {
    urlsWithHttp() {
      // Assume URLs in 'urls' prop are relative paths to the public folder
      return this.urls.map(url => `/${this.projectKey}/${url}`);
    }
  }
};
</script>

<style scoped>
.url-list {
  margin-top: 20px;
}

.image-scroll-container {
  overflow-x: auto;
  white-space: nowrap;
}

.image-container {
  display: inline-block;
}

.video-container {
  margin-bottom: 20px;
}

.video-item {
  width: auto;
  max-width: 500px;
  height: auto;
  margin-top: 10px;
}
</style>
